exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/map-config-offers/map-config-offers.component.scss
// module id = ../../../../../src/app/components/map-config-offers/map-config-offers.component.scss
// module chunks = main